import varAxios from "../../../Comman/axios";
import { pendingHeartRunnerListUrl, updatePendingHeartRunnerListUrl,GetRegionListUrl  }
     from "../../../Comman/apiEndPoints"

export const FETCH_PENDING_HEARTRUNNER_REQUEST = "(fetch) FETCH PENDING HEARTRUNNER REQUEST";
export const FETCH_PENDING_HEARTRUNNER_SUCCESS = "(fetch) FETCH PENDING HEARTRUNNER SUCCESS";
export const FETCH_PENDING_HEARTRUNNER_ERROR = "(fetch) FETCH PENDING HEARTRUNNER ERROR";

export const UPDATE_PENDING_HEARTRUNNER_REQUEST = "(update) UPDATE PENDING HEARTRUNNER REQUEST";
export const UPDATE_PENDING_HEARTRUNNER_SUCCESS = "(update) UPDATE PENDING HEARTRUNNER SUCCESS";
export const UPDATE_PENDING_HEARTRUNNER_ERROR = "(update) UPDATE PENDING HEARTRUNNER ERROR";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";

export function fetchHeartRunnerDetail(RegionId,dispatch) {
   

    return (dispatch) => {
        dispatch(fetchHeartRunnerDetailRequest(true));

        return varAxios.post(pendingHeartRunnerListUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchHeartRunnerDetailSuccess(false, response.data.List,response.data.statusCode) 
                );
            })
            .catch((error) => {
                
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        fetchHeartRunnerDetail(RegionId,dispatch)
                    );
                }
            })
    }
}
/* export function fetchHeartRunnerDetail(dispatch) {
   

    return (dispatch) => {
        dispatch(fetchHeartRunnerDetailRequest(true));

        return varAxios.post(pendingHeartRunnerListUrl,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchHeartRunnerDetailSuccess(false, response.data.List,response.data.statusCode) 
                );
            })
            .catch((error) => {
                
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        fetchHeartRunnerDetail( dispatch)
                    );
                }
            })
    }
} */

export function fetchHeartRunnerDetailRequest(isLoading) {
    return {
        type: FETCH_PENDING_HEARTRUNNER_REQUEST,
        isLoading
    }
}

export function fetchHeartRunnerDetailSuccess(isLoading, pendingHeartRunnerList,statusCode) {
    return {
        type: FETCH_PENDING_HEARTRUNNER_SUCCESS,
        isLoading,
        pendingHeartRunnerList,
        statusCode
    }
}

export function approveHeartRunner(isLoading, deviceList, dispatch1) {
    var approveHeartRunnerList = [];
    approveHeartRunnerList = deviceList;


    return (dispatch) => {
        dispatch(updateDeviceDetailRequest(true));

        return varAxios.post(updatePendingHeartRunnerListUrl, approveHeartRunnerList,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateDeviceDetailSuccess(false, 
                        response.data.firstResponderUsersList, 
                        response.data.errorMessage,
                        response.data.statusCode
                        )
                );
                 this.fetchHeartRunnerDetail({RegionId:dispatch1})
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        approveHeartRunner(isLoading, deviceList, dispatch)
                    );
                     this.fetchHeartRunnerDetail({RegionId:dispatch1})
                }
            })
    }
}

export function rejectHeartRunner(isLoading, deviceList, dispatch1) {
    var rejectHeartRunnerList = [];    
    rejectHeartRunnerList.push(deviceList)

    return (dispatch) => {
        dispatch(updateDeviceDetailRequest(true));

        return varAxios.post(updatePendingHeartRunnerListUrl, rejectHeartRunnerList,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                
                dispatch(
                    updateDeviceDetailSuccess(false, 
                        response.data.firstResponderUsersList, 
                        response.data.errorMessage,
                        response.data.statusCode,

                        )
                );
                 this.fetchHeartRunnerDetail({RegionId:dispatch1})
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        rejectHeartRunner(isLoading, deviceList, dispatch)
                    );
                }
            })
    }
}

export function updateDeviceDetailRequest(isLoading) {
    return {
        type: UPDATE_PENDING_HEARTRUNNER_REQUEST,
        isLoading
    }
}

export function updateDeviceDetailSuccess(isLoading, pendingHeartRunnerList, messageLabel,statusCode) {
    
    return {
        type: UPDATE_PENDING_HEARTRUNNER_SUCCESS,
        isLoading,
        pendingHeartRunnerList,
        messageLabel,
        statusCode
    }
}
export function getAllRegionSettings() {
     let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        this.fetchHeartRunnerDetail({RegionId:response.data.regionList[0].ID})
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}